import React from 'react';

import { Heading } from '@chakra-ui/react';

import { DOCUMENTATION_FONT_FAMILY } from '../utils';

/** A section title on an API reference page (Parameters, Response, ...). */
export const ApiSectionHeading = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Heading
    as="h2"
    fontFamily={DOCUMENTATION_FONT_FAMILY}
    fontSize="21px"
    fontWeight={600}
    color="black"
    mb={3}
  >
    {children}
  </Heading>
);
